import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError, Observable, Subject, interval, Subscription} from 'rxjs';
import { environment } from './../../environments/environment'

const _commTimer = interval(300);

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  private _commTimerSubscription: Subscription;

  constructor() {
    this._commTimerSubscription = null;
  }

  private Communicating: Subject<boolean> = new Subject<boolean>();

  private _IsComm: Boolean;

  getApiAddress(): string {
    return environment.apiServer + "/v1/api";
  }

  setComm(s: boolean) {
    this._IsComm = s;

    if (s) {
      this.Communicating.next(true);
      if (this._commTimerSubscription == null || this._commTimerSubscription.closed) {
        this._commTimerSubscription = _commTimer.subscribe(
          r => {
            console.log("Waiting " + r);
            if (!this._IsComm) {
              if (!this._commTimerSubscription.closed) {
                this._commTimerSubscription.unsubscribe();
                this.Communicating.next(false);
              }
            }
          }
        );
      }
    }    
  }

  OnInterception(): Observable<boolean> {
    return this.Communicating.asObservable();
  }

  handleError(sub: string, e: HttpErrorResponse) {
    let em: string;
    if (e.error instanceof ErrorEvent) {
      em = 'Local error : ', e.error.message;
    } else {
      em = 'Server error ' + e.status + ' : ' + e.error;
    }
    return throwError(sub + ' ' + em);
  }

}